module.exports = __webpack_public_path__ + "assets/img/bg-prize-3.c1a0adbb.png";